import { useMemo } from "react";
import { useSelector } from "react-redux";

import { RootState } from "@/reducers/types";
import { useLoginUser } from "@/sx-layout/hooks/useLoginUser";
import { normalizeHexColor } from "@/sx-layout/utils";

export const useUserCompanyColor = () => {
  const { loginUser } = useLoginUser();
  const companies = useSelector((state: RootState) => state.layoutApp.layoutMasters.companies);

  const loginUserCompanyIconColor = useMemo(() => {
    const loginUserCompanyId = loginUser?.company_id;
    if (!companies || companies.length === 0 || !loginUserCompanyId) return undefined;
    const loggedInUserCompany = companies.find((company) => company.company_id === loginUserCompanyId);

    return normalizeHexColor(loggedInUserCompany?.icon_color);
  }, [loginUser, companies]);

  return { loginUserCompanyIconColor };
};
